import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _dcbcf7a6 = () => interopDefault(import('../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _629f2a08 = () => interopDefault(import('../pages/console/index.vue' /* webpackChunkName: "pages/console/index" */))
const _00a8daba = () => interopDefault(import('../pages/auth/forgot-password/index.vue' /* webpackChunkName: "pages/auth/forgot-password/index" */))
const _5b492744 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _775b4f9b = () => interopDefault(import('../pages/auth/register/index.vue' /* webpackChunkName: "pages/auth/register/index" */))
const _f121dfb2 = () => interopDefault(import('../pages/auth/status.vue' /* webpackChunkName: "pages/auth/status" */))
const _70c1e1ae = () => interopDefault(import('../pages/auth/status-admin.vue' /* webpackChunkName: "pages/auth/status-admin" */))
const _76c52c3a = () => interopDefault(import('../pages/auth/update-password.vue' /* webpackChunkName: "pages/auth/update-password" */))
const _db636b10 = () => interopDefault(import('../pages/console/calendar.vue' /* webpackChunkName: "pages/console/calendar" */))
const _2ef8b568 = () => interopDefault(import('../pages/console/calendarScript.js' /* webpackChunkName: "pages/console/calendarScript" */))
const _1f7a0b8d = () => interopDefault(import('../pages/console/consultation-history/index.vue' /* webpackChunkName: "pages/console/consultation-history/index" */))
const _1b6b3bca = () => interopDefault(import('../pages/console/dashboard.vue' /* webpackChunkName: "pages/console/dashboard" */))
const _7cc2b73a = () => interopDefault(import('../pages/console/dashboardScript.js' /* webpackChunkName: "pages/console/dashboardScript" */))
const _cc2dd162 = () => interopDefault(import('../pages/console/faq/index.vue' /* webpackChunkName: "pages/console/faq/index" */))
const _26ea1d90 = () => interopDefault(import('../pages/console/finance.vue' /* webpackChunkName: "pages/console/finance" */))
const _489fffbc = () => interopDefault(import('../pages/console/indexScript.js' /* webpackChunkName: "pages/console/indexScript" */))
const _0a63dbc5 = () => interopDefault(import('../pages/console/oldindex.vue' /* webpackChunkName: "pages/console/oldindex" */))
const _30f4d7df = () => interopDefault(import('../pages/console/profile.vue' /* webpackChunkName: "pages/console/profile" */))
const _669f3f76 = () => interopDefault(import('../pages/console/profileScript.js' /* webpackChunkName: "pages/console/profileScript" */))
const _1af5d41e = () => interopDefault(import('../pages/console/report/index.vue' /* webpackChunkName: "pages/console/report/index" */))
const _5abe2604 = () => interopDefault(import('../pages/console/telegram/index.vue' /* webpackChunkName: "pages/console/telegram/index" */))
const _b536de4c = () => interopDefault(import('../pages/auth/forgot-password/verification.vue' /* webpackChunkName: "pages/auth/forgot-password/verification" */))
const _d0966148 = () => interopDefault(import('../pages/auth/register/complete-profile.vue' /* webpackChunkName: "pages/auth/register/complete-profile" */))
const _4bdd45ae = () => interopDefault(import('../pages/console/consultation-history/detail.js' /* webpackChunkName: "pages/console/consultation-history/detail" */))
const _7e89e386 = () => interopDefault(import('../pages/console/faq/foi-medicine/index.vue' /* webpackChunkName: "pages/console/faq/foi-medicine/index" */))
const _704e1d73 = () => interopDefault(import('../pages/console/report/indexScript.js' /* webpackChunkName: "pages/console/report/indexScript" */))
const _413f8d35 = () => interopDefault(import('../pages/console/consultation-history/_id.vue' /* webpackChunkName: "pages/console/consultation-history/_id" */))
const _388d1627 = () => interopDefault(import('../pages/payment/detail/_id.vue' /* webpackChunkName: "pages/payment/detail/_id" */))
const _13b69280 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _650fd37d = () => interopDefault(import('../pages/_doctorNickName/_clinicName.vue' /* webpackChunkName: "pages/_doctorNickName/_clinicName" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/auth",
    component: _dcbcf7a6,
    name: "auth"
  }, {
    path: "/console",
    component: _629f2a08,
    name: "console"
  }, {
    path: "/auth/forgot-password",
    component: _00a8daba,
    name: "auth-forgot-password"
  }, {
    path: "/auth/login",
    component: _5b492744,
    name: "auth-login"
  }, {
    path: "/auth/register",
    component: _775b4f9b,
    name: "auth-register"
  }, {
    path: "/auth/status",
    component: _f121dfb2,
    name: "auth-status"
  }, {
    path: "/auth/status-admin",
    component: _70c1e1ae,
    name: "auth-status-admin"
  }, {
    path: "/auth/update-password",
    component: _76c52c3a,
    name: "auth-update-password"
  }, {
    path: "/console/calendar",
    component: _db636b10,
    name: "console-calendar"
  }, {
    path: "/console/calendarScript",
    component: _2ef8b568,
    name: "console-calendarScript"
  }, {
    path: "/console/consultation-history",
    component: _1f7a0b8d,
    name: "console-consultation-history"
  }, {
    path: "/console/dashboard",
    component: _1b6b3bca,
    name: "console-dashboard"
  }, {
    path: "/console/dashboardScript",
    component: _7cc2b73a,
    name: "console-dashboardScript"
  }, {
    path: "/console/faq",
    component: _cc2dd162,
    name: "console-faq"
  }, {
    path: "/console/finance",
    component: _26ea1d90,
    name: "console-finance"
  }, {
    path: "/console/indexScript",
    component: _489fffbc,
    name: "console-indexScript"
  }, {
    path: "/console/oldindex",
    component: _0a63dbc5,
    name: "console-oldindex"
  }, {
    path: "/console/profile",
    component: _30f4d7df,
    name: "console-profile"
  }, {
    path: "/console/profileScript",
    component: _669f3f76,
    name: "console-profileScript"
  }, {
    path: "/console/report",
    component: _1af5d41e,
    name: "console-report"
  }, {
    path: "/console/telegram",
    component: _5abe2604,
    name: "console-telegram"
  }, {
    path: "/auth/forgot-password/verification",
    component: _b536de4c,
    name: "auth-forgot-password-verification"
  }, {
    path: "/auth/register/complete-profile",
    component: _d0966148,
    name: "auth-register-complete-profile"
  }, {
    path: "/console/consultation-history/detail",
    component: _4bdd45ae,
    name: "console-consultation-history-detail"
  }, {
    path: "/console/faq/foi-medicine",
    component: _7e89e386,
    name: "console-faq-foi-medicine"
  }, {
    path: "/console/report/indexScript",
    component: _704e1d73,
    name: "console-report-indexScript"
  }, {
    path: "/console/consultation-history/:id?",
    component: _413f8d35,
    name: "console-consultation-history-id"
  }, {
    path: "/payment/detail/:id?",
    component: _388d1627,
    name: "payment-detail-id"
  }, {
    path: "/",
    component: _13b69280,
    name: "index"
  }, {
    path: "/:doctorNickName/:clinicName?",
    component: _650fd37d,
    name: "doctorNickName-clinicName"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
